import { Navigate, useRoutes } from "react-router-dom";

import {
  AddNewSubjectPage,
  AddSubjectToClassPage,
  ALLEducationalInstitutionsPage,
  AllSubjectsPage,
  LoginPage,
  SchoolFamiliesPage,
  AddNewFamilyPage,
  SchoolStudentsPage,
  AddNewStudentPage,
  AddNewClassesPage,
  AddSectionToClassPage,
  AddNewAdsToSchoolPage,
  SchoolAdsPage,
  SchoolTeachersPage,
  AddTeacherToSchoolPage,
  StudentsGradesPage,
  AddGradeForStudentPage,
  StudentsNotesPage,
  AddNotesForStudentPage,
  DivisionInfoPage,
  AllMinisterialDecisions,
  ReceiveNotes,
  EducationalInstitutionProfile,
  AddTimeSlotForDivisionPage,
  NewEducationalInstitutionInfoPage,
  AddImageToSchool,
  EditExistStudentPage,
  AllSecretariesPage,
  SchoolClassesPage,
  AddEducationalInstitutionPage,
  AddNewSecretaryPage,
  StudentForFamilyPage,
  EditFamilyPage,
  EditTeacherPage,
  ReceiveNotesFromParentPage,
  SendingNotesFromSchoolPage,
  AllStudentsPage,
  EditEducationalInstitutionPage,
  QuestionsOfSamples,
  AddQuestionToSample,
  SectionInfoPage,
  AddTimeSlotForSectionPage,
  EditSectionPage,
  StudentInfoPage,
  StudentPaymentInfoPage,
  AddPaymentForStudentPage,
  AllSamples,
  AddNewSample,
  AddMinisterialDecisionPage,
  SchoolSessionsPage,
  AddSessionsToTeacherPage,
  AddImageToQuestion,
  AddPublicAdsPage,
  PublicAdsPage,
  StudentResult,
} from "./elements";
import DashboardLayout from "../layouts/dashboard/DashboardLayout";
import ManagmentDashboardLayout from "../layouts/managment-dashboard/ManagmentDashboardLayout";
import AuthAdminGuard from "../auth/AuthAdminGuard";
import SendNotificaationPage from "../pages/@dashboard/school-notifications/SendNotificaationPage";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: "/",
      children: [
        // { element: <Navigate to="auth/register" replace />, index: true },
        { element: <Navigate to="auth/login" replace />, index: true },
        { path: "auth/login", element: <LoginPage /> },
      ],
    },

    // Dashboard
    {
      path: "dashboard",
      element: (
        <>
          <DashboardLayout />
        </>
      ),
      children: [
        { element: <Navigate to="/dashboard/overview" replace />, index: true },
        { path: "overview", element: <h1> Welcome from dashboard </h1> },
        {
          path: "classes",
          children: [
            {
              path: "",
              element: <SchoolClassesPage />,
            },
            {
              path: "add-subject-to-class",
              element: <AddSubjectToClassPage />,
            },
            {
              path: "add-new-class",
              element: <AddNewClassesPage />,
            },
            {
              path: "add-section-to-class",
              element: <AddSectionToClassPage />,
            },
            {
              path: "section-info",
              element: <SectionInfoPage />,
            },
            {
              path: "edit-section",
              element: <EditSectionPage />,
            },
            {
              path: "add-time-solt",
              element: <AddTimeSlotForSectionPage />,
            },
          ],
        },
        {
          path: "families",
          children: [
            {
              path: "",
              element: <SchoolFamiliesPage />,
            },
            {
              path: "add-new-family",
              element: <AddNewFamilyPage />,
            },
            {
              path: "edit-family",
              element: <EditFamilyPage />,
            },
            {
              path: "add-student-to-family",
              element: <AddNewStudentPage />,
            },
            {
              path: "family-students",
              element: <StudentForFamilyPage />,
            },
          ],
        },
        {
          path: "students",
          children: [
            {
              path: "",
              element: <SchoolStudentsPage />,
            },
            {
              path: "student-info",
              element: <StudentInfoPage />,
            },
            {
              path: "edit-student",
              element: <EditExistStudentPage />,
            },
            {
              path: "payment-info",
              element: <StudentPaymentInfoPage />,
            },
            {
              path: "add-payment",
              element: <AddPaymentForStudentPage />,
            },
            {
              path: "grades",
              children: [
                {
                  path: "",
                  element: <StudentsGradesPage />,
                },
                {
                  path: "add-new-grade",
                  element: <AddGradeForStudentPage />,
                },
              ],
            },
            {
              path: "results",
              children: [
                {
                  path: "",
                  element: <StudentResult />,
                },
              ],
            },
            {
              path: "add-new-notes",
              element: <AddNotesForStudentPage />,
            },
          ],
        },
        {
          path: "receiving-notes",
          element: <ReceiveNotesFromParentPage />,
        },
        {
          path: "sending-notes",
          element: <SendingNotesFromSchoolPage />,
        },
        {
          path: "teachers",
          children: [
            {
              path: "",
              element: <SchoolTeachersPage />,
            },
            {
              path: "add-new-teacher",
              element: <AddTeacherToSchoolPage />,
            },
            {
              path: "edit-teacher",
              element: <EditTeacherPage />,
            },
            {
              path: "teacher-sessions",
              element: <SchoolSessionsPage />,
            },
            {
              path: "add-new-session",
              element: <AddSessionsToTeacherPage />,
            },
          ],
        },
        {
          path: "ads",
          children: [
            {
              path: "",
              element: <SchoolAdsPage />,
            },
            {
              path: "add-new-ads",
              element: <AddNewAdsToSchoolPage />,
            },
          ],
        },
        {
          path: "notifications",
          children: [
            {
              path: "",
              element: <SendNotificaationPage />,
            },
          ],
        },
        {
          path: "school-profile",
          children: [
            {
              path: "",
              element: <EducationalInstitutionProfile />,
            },
            {
              path: "edit-school",
              element: <EditEducationalInstitutionPage />,
            },
          ],
        },
      ],
    },
    // =============  @@@@ EMPLOYEE @@@@ =========
    {
      path: "manager",
      element: (
        <AuthAdminGuard>
          <ManagmentDashboardLayout />,
        </AuthAdminGuard>
      ),
      children: [
        {
          element: <Navigate to="/manager/overview" replace />,
          index: true,
        },
        { path: "overview", element: <></> },
        {
          path: "educational_institution",
          children: [
            {
              path: "",
              element: <ALLEducationalInstitutionsPage />,
            },
            {
              path: "edit-school",
              element: <EditEducationalInstitutionPage />,
            },
          ],
        },
        {
          path: "ministerial_decisions",
          children: [
            {
              path: "",
              element: <AllMinisterialDecisions />,
            },
            {
              path: "add-new-ministerial",
              element: <AddMinisterialDecisionPage />,
            },
          ],
        },
        {
          path: "samples",
          children: [
            {
              path: "",
              element: <AllSamples />,
            },
            { path: "add-new-sample", element: <AddNewSample /> },
            {
              path: "questions",
              children: [
                {
                  path: "",
                  element: <QuestionsOfSamples />,
                },
                {
                  path: "add-new-question",
                  element: <AddQuestionToSample />,
                },
                {
                  path: "add-image-to-question",
                  element: <AddImageToQuestion />,
                },
              ],
            },
          ],
        },
        {
          path: "add-new-school",
          element: <AddEducationalInstitutionPage />,
        },
        {
          path: "new-educational-institution-info",
          element: <NewEducationalInstitutionInfoPage />,
        },
        {
          path: "add-image-to-school",
          element: <AddImageToSchool />,
        },
        {
          path: "students",
          element: <AllStudentsPage />,
        },
        {
          path: "teachers",
          element: <></>,
        },
        {
          path: "ads",
          children: [
            {
              path: "",
              element: <PublicAdsPage />,
            },
            {
              path: "add-public-ads",
              element: <AddPublicAdsPage />,
            },
          ],
        },
        {
          path: "contact-us",
          element: <></>,
        },
        {
          path: "profile",
          element: <></>,
        },
        {
          path: "secretaries",
          children: [
            {
              path: "",
              element: <AllSecretariesPage />,
            },
            {
              path: "add-new-secretary",
              element: <AddNewSecretaryPage />,
            },
          ],
        },
        {
          path: "subjects",
          children: [
            { path: "", element: <AllSubjectsPage /> },
            { path: "add-subject", element: <AddNewSubjectPage /> },
          ],
        },
      ],
    },

    { path: "/500", element: <></> },
    { path: "/404", element: <></> },
  ]);
}
